import { Component, OnInit } from '@angular/core';
import { UserService } from '../user.service';
import { Email } from '../../buyer/interfaces/Email';
import {EmailService} from '../../services/email.service';
import { SessionService } from '../../services/session.service';
import { SharedService } from '../../shared/shared.service';
import { TopService } from '../../shared/services/top.service';
import { FormsModule } from '@angular/forms';
import { NgIf } from '@angular/common';
import { ISessionInfo, ISupportMessage, ISupportMessageRequest } from '../../shared/interfaces/model';


@Component({
    selector: 'app-user-support',
    templateUrl: './user-support.component.html',
    styleUrls: ['./user-support.component.scss'],
    standalone: true,
    imports: [NgIf, FormsModule]
})
export class UserSupportComponent implements OnInit {
  complete = false;
  public message = '';
  private isBuyer = false;
  private isVendor = false;

  constructor(private userService: UserService,
    private emailService: EmailService,
    private sessionService: SessionService,
    private sharedService: SharedService,
    public topService: TopService) { }

  ngOnInit() {
    if (this.sessionService.userRole === 'BUYER')
      this.isBuyer = true;
    else if (this.sessionService.userRole === 'SELLER')
      this.isVendor = true;

    if (!this.userService.userProfile) {
      this.userService.getLoggedInUserProfile().subscribe(data => {
        this.userService.userProfile = Object.assign({},data);
      });
    }
    if ((this.isBuyer || this.isVendor) && !this.userService.bpCode && !this.userService.companyName) {
      this.userService.getProfile().subscribe(data => {
        this.userService.bpCode = data.bpCode;
        this.userService.companyName = data.companyName;
      });
    }
  }
  submitForm(): void {
    this.submitFormAsync();
  }
  async submitFormAsync(): Promise<void> {
    let sessionInfo = {
        role:this.sessionService.userRole,
        userId:this.sessionService._user_id,
        isCustomerSelected:this.sessionService.isCustomerSelected === 'YES',
        selectedCustomer:this.sessionService.selectedCustomer,
        partnerId:this.sessionService.partnerId,
        sessionId:sessionStorage.getItem('sessionId') || '',
        userEmail:this.sessionService.userEmail,
        isLoggedIn:this.sessionService.isLoggedIn === 'true'
    } as ISessionInfo;

    let supportMessage = {
      timestamp: new Date(),
      message: this.message.trim()
    } as ISupportMessage;

    let supportMessageRequest = {
      user: this.userService.userProfile,
      bpProfile: this.isBuyer || this.isVendor ? this.sharedService.profileData : this.userService.businessPartnersProfile,
      sessionInfo : sessionInfo,
      supportMessage: supportMessage
    } as ISupportMessageRequest;
    try{
      var response = await this.userService.submitSupportMessage(supportMessageRequest);
      //console.log(response);
    } catch (err){
      //console.error('Error submitting support message:', err);
    }
    finally{
      this.complete = true;
    }

  }

  resetForm():void{
    this.complete = false;
    this.message = '';
  }
}
